(function() {
  if (window.__sidecartRecLoaded) return;
  window.__sidecartRecLoaded = true;

  const CONFIG = {
    observeId: 'CartContainer',
    injectionClass: 'sidecart-rec-injected',
    cartDataUrl: '/cart.js',
    recApiUrl: '/recommendations/products.json',
    addToCartUrl: '/cart/add.js'
  };

  let isProcessing = false;

  /**
   * 1. DATA FETCHERS
   * Responsible only for grabbing data from Shopify APIs.
   */
  async function fetchCurrentCart() {
    const response = await fetch(CONFIG.cartDataUrl);
    return await response.json();
  }

function getPinnedProducts() {
  const jsonElement = document.getElementById('sidecart-pinned-products');
  if (!jsonElement) return [];
  
  try {
    const data = JSON.parse(jsonElement.textContent);
    return data.enabled ? data.products : [];
  } catch (e) {
    console.error("Failed to parse pinned products JSON", e);
    return [];
  }
}

  async function fetchRecommendedProduct(productId) {
    const url = `${CONFIG.recApiUrl}?product_id=${productId}&limit=10`;
    const response = await fetch(url);
    const data = await response.json();
    return data.products || [];
  }

function getPinnedVariantId() {
    const pinnedElem = document.getElementById('PinnedUpsells');
    if (!pinnedElem) return null;

    const ids = pinnedElem.getAttribute('data-pinned-ids').split(',').filter(id => id !== "");
    
    // Logic: Return the first pinned ID that isn't already in the cart
    // For now, let's just grab the first one for simplicity
    return ids.length > 0 ? ids[0] : null;
  }

  // We need an extra fetcher if we only have a Variant ID but need Product details
  async function fetchProductByVariantId(variantId) {
    // Shopify doesn't have a direct /products/by-variant-id, so we fetch the 
    // search or specific recommendation. Easier way: use the /cart/add.js 
    // success object or a simplified search.
    const res = await fetch(`/search/suggest.json?q=variant:${variantId}&resources[type]=product`);
    const data = await res.json();
    return data.resources.products ? data.resources.products[0] : null;
  }


  /**
   * 2. UI BUILDERS
   * Responsible for creating HTML elements and formatting strings.
   */
  function formatCurrency(price) {
    return (price / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

function createRecMarkup(product) {
  const img = product.featured_image || product.image;
  const variants = product.variants || [];
  const hasVariants = variants.length > 1;
  const firstVariant = variants[0];
  const vId = product.variantId || (firstVariant && firstVariant.id);
  const price = product.priceFormatted || formatCurrency(product.price);

  const variantOptions = hasVariants
    ? variants.map(v => `<option value="${v.id}" data-price="${v.price}">${v.title}</option>`).join('')
    : '';

  const container = document.createElement('div');
  container.className = CONFIG.injectionClass;
  container.innerHTML = `
    <div class="sidecart-rec-flex">
      <div class="sidecart-rec-banner" aria-hidden="true">Recommended for You</div>
      <img src="${img}" class="sidecart-rec-image">
      <div class="sidecart-rec-info">
        <div class="sidecart-rec-product-title">${product.title}</div>
        <div class="sidecart-rec-price">${price}</div>
        ${hasVariants ? `<select class="sidecart-rec-variant-select">${variantOptions}</select>` : ''}
        <button type="button" class="btn btn--full sidecart-rec-btn" data-variant-id="${vId}">
          Add to Cart
        </button>
      </div>
    </div>`;

  if (hasVariants) {
    const select = container.querySelector('.sidecart-rec-variant-select');
    const btn = container.querySelector('.sidecart-rec-btn');
    const priceEl = container.querySelector('.sidecart-rec-price');
    select.addEventListener('change', function() {
      btn.dataset.variantId = this.value;
      const opt = this.options[this.selectedIndex];
      if (opt.dataset.price) priceEl.textContent = formatCurrency(parseInt(opt.dataset.price));
    });
  }

  return container;
}

  /**
   * 3. ACTIONS & REFRESH LOGIC
   * Logic for updating the cart state and refreshing the UI.
   */
  function refreshCartUI(variantId) {
    // Attempt standard Timber/Slate refresh
    if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
      ajaxCart.load();
    } else {
      // Fallback triggers for jQuery or custom events
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { variantId } }));
      if (window.jQuery) {
        jQuery(document).trigger('change');
        jQuery(document.body).trigger('added.ajaxcart');
      }
    }
  }

  window.handleRecAddToCart = async function(variantId) {
    const response = await fetch(CONFIG.addToCartUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!response.ok) throw new Error('Add to cart failed');
    refreshCartUI(variantId);
  };

  /**
   * 4. COORDINATOR
   * Orchestrates the flow of data and DOM manipulation.
   */
async function runRecommendationEngine() {
  const cartContainer = document.getElementById(CONFIG.observeId);
  if (isProcessing || !cartContainer) return;

  isProcessing = true;

  try {
    const cart = await fetchCurrentCart();
    const existingRec = cartContainer.querySelector('.' + CONFIG.injectionClass);

    const pinnedProducts = getPinnedProducts();
    console.log(pinnedProducts);

    if (cart.item_count === 0 && pinnedProducts.length === 0) {
      if (existingRec) existingRec.remove();
      return;
    }

    if (existingRec) return;

    let selectedProduct = null;

    for (const product of pinnedProducts) {
      // Logic: Is this product ID already in the cart items?
      const alreadyInCart = cart.items.some(item => item.product_id == product.id);
      if (!alreadyInCart) {
        selectedProduct = product; 
        break; 
      }
    }

    // 3. Priority 2: Fallback to AI Recommendations API
    if (!selectedProduct && cart.items.length > 0) {
      const seedItems = cart.items.slice(0, 4);
      const results = await Promise.all(seedItems.map(item => fetchRecommendedProduct(item.product_id)));

      const freq = {};
      results.flat().forEach(rec => {
        if (!freq[rec.id]) freq[rec.id] = { count: 0, product: rec };
        freq[rec.id].count++;
      });

      const ranked = Object.values(freq)
        .sort((a, b) => b.count - a.count)
        .map(e => e.product);

      selectedProduct = ranked.find(rec =>
        rec.vendor === 'Jigsaw Health' &&
        !cart.items.some(item => item.product_id == rec.id)
      ) || null;
    }

    // 4. Render the Winner
    const innerWrapper = cartContainer.querySelector('.ajaxcart__inner');
    if (selectedProduct && innerWrapper) {
      const recElement = createRecMarkup(selectedProduct);
      
      recElement.querySelector('button').addEventListener('click', async function() {
        const btn = this;
        const variantId = btn.dataset.variantId || selectedProduct.variantId;
        btn.disabled = true;
        const original = btn.textContent;
        btn.textContent = 'Adding…';
        try {
          await handleRecAddToCart(variantId);
          btn.textContent = 'Added ✓';
          btn.classList.add('added');
          setTimeout(() => {
            btn.textContent = original;
            btn.classList.remove('added');
            btn.disabled = false;
          }, 1400);
        } catch {
          btn.textContent = original;
          btn.disabled = false;
        }
      });

      innerWrapper.appendChild(recElement);
    }

  } catch (e) {
    console.error("Engine failure:", e);
  } finally {
    isProcessing = false;
  }
}

  /**
   * 5. INITIALIZER & OBSERVER
   * Watches for changes and starts the engine.
   */
  const observer = new MutationObserver((mutations) => {
    const hasValidChanges = mutations.some(m => 
      m.type === 'childList' && 
      !Array.from(m.addedNodes).some(n => n.classList && n.classList.contains(CONFIG.injectionClass))
    );

    if (hasValidChanges) {
      setTimeout(runRecommendationEngine, 50);
    }
  });

  console.log('pinnedProducts on load:', getPinnedProducts());

  const target = document.getElementById(CONFIG.observeId);
  if (target) {
    observer.observe(target, { childList: true, subtree: true });
    runRecommendationEngine();
  }
})();
